import React, { useState } from "react";
import AppBarTopHeader from "@carrier-io/air-react/patterns/AppBarTopHeader";
import { Avatar, Divider, SvgIcon } from "@carrier-io/air-react";
import Box from "@carrier-io/air-react/Box";
import Grid from "@carrier-io/air-react/Grid";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useNavigate } from "react-router-dom";
import { RoutesPage } from "../../constants/routes";
import { colors } from "../../styles/colors";
import Popover from "@carrier-io/air-react/Popover";
import Typography from "@carrier-io/air-react/Typography";
import { Button } from "../button/Button";
import { CustomPolicy, CustomTerms } from "../terms";
import { useUser } from "../../contexts/user/userContext";
import { ThemeProvider, createTheme } from "@carrier-io/air-react/styles";
import { deleteLoginCookies } from "../../utils/cookie";

const customTheme = createTheme({
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#00000061 !important",
          textDecoration: "none",
          fontFamily: '"Red Hat Text", sans-serif',
          fontOpticalSizing: "auto",
          fontStyle: "normal",
          "&:hover": {
            textDecoration: "none",
          },
        },
      },
    },
  },
});
export const AdminHeader = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { user: currentUser } = useUser();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Box sx={{ gridArea: "header" }}>
      <AppBarTopHeader
        toolbarProps={{
          disableGutters: true,
          sx: {
            backgroundColor: `${colors.toolbarBackground}`,
            minHeight: "64px",
            padding: "8px 12px",
          },
          variant: "dense",
        }}
        leftJustifiedComponent={
          <SvgIcon fontSize="medium">
            <path
              d="M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z"
              fill="#63676B"
            />
          </SvgIcon>
        }
        rightJustifiedComponent={
          <Box>
            <Avatar
              variant="circular"
              sx={{
                backgroundColor: `${colors.avatarBackground}`,
              }}
              onClick={handleClick}
            >
              <PersonOutlineOutlinedIcon />
            </Avatar>
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  minWidth: "248px",
                  maxWidth: "fit-content",
                }}
              >
                <Box
                  sx={{
                    padding: "24px 25px",
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Avatar
                    variant="circular"
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: `${colors.avatarBackground}`,
                    }}
                  >
                    <PersonOutlineOutlinedIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="body1Semibold">
                      {`${currentUser?.firstName} ${currentUser?.lastName}`}
                    </Typography>
                    <Typography variant="body2">
                      {currentUser?.email}
                    </Typography>
                  </Box>
                </Box>
                <Divider variant="full"></Divider>
                <Box sx={{ padding: "24px 25px" }}>
                  <Button
                    color="primary"
                    onClick={() => {
                      handleClose();
                      navigate(RoutesPage.UpdateProfile);
                    }}
                    variant="text"
                    sx={{ width: "100%" }}
                  >
                    Update your profile
                  </Button>
                </Box>
                <Divider variant="full"></Divider>
                <Box sx={{ padding: "24px 25px" }}>
                  <Button
                    color="primary"
                    onClick={() => {
                      handleClose();
                      deleteLoginCookies(window.location.hostname);
                      navigate(RoutesPage.Login);
                    }}
                    variant="outlined"
                    sx={{ width: "100%" }}
                  >
                    Sign out
                  </Button>
                  <Grid
                    container
                    direction={"row"}
                    spacing={1}
                    sx={{
                      marginTop: 1,
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Grid>
                      <ThemeProvider theme={customTheme}>
                        <CustomPolicy />
                      </ThemeProvider>
                    </Grid>
                    <Grid>
                      <ThemeProvider theme={customTheme}>
                        <CustomTerms />
                      </ThemeProvider>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Popover>
          </Box>
        }
      />
    </Box>
  );
};
